import type { ChildrenProps } from "../types";

export function TimelineRow({ children }: ChildrenProps) {
	/** Render */
	return <div className="gap-2 grid grid-cols-[50px_1fr]">{children}</div>;
}
